import styled from 'styled-components'

// Text for screen readers only: out of flow and clipped to nothing, but still rendered, so it stays in
// the accessibility tree. display:none or visibility:hidden would remove it from the tree instead.
const ScreenReaderOnly = styled.div`
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`

export default ScreenReaderOnly
